// JavaScript Document
$(function() {
	/*-----------------------------------
		PC・SP判定
	-----------------------------------*/
	//サイズ
	var w = $(window).width();
	var x = 812;
	
	
	/*-----------------------------------
		switch
	-----------------------------------*/
	var $setElem = $('.switch'),
	pcName = '_pc',
	spName = '_sp',
	replaceWidth = 812;

	$setElem.each(function(){
		var $this = $(this);
		function imgSize(){
			if(window.innerWidth > replaceWidth) {
				$this.attr('src',$this.attr('src').replace(spName,pcName)).css({visibility:'visible'});
			} else {
				$this.attr('src',$this.attr('src').replace(pcName,spName)).css({visibility:'visible'});
			}
		}
		$(window).resize(function(){imgSize();});
		imgSize();
	});
	
	
	/*-----------------------------------
		ScrollTrigger　アニメーション（ScrollTrigger.min.js / gsap.min.js必要）
	-----------------------------------*/
	gsap.utils.toArray('[class *= "jsAnm"]').forEach((target) => {//アニメーションしたい要素
		// console.log(target);
		// アニメーション開始クラス付与
		gsap.timeline({
			scrollTrigger: {
				trigger:target,//アニメーションが始まるトリガーとなる要素
				start:'top bottom',
				end:  'top 90%',
				onLeave: () => target.classList.add('jsAnmStart'),
				// onLeaveBack: () => target.classList.remove('jsAnmStart'), //複数回アニメーション用（一回のみの時はコメントアウト）
				// markers:true,
			}
		});
	});

	
	/*-----------------------------------
		scroller (jquery.easing.1.3.jsとセット)
	-----------------------------------*/
	//パラメータ保存用オブジェクトの作成
	if (typeof(tora) == "undefined"){
		tora = new Object;
	}
	tora.scroller = function(){
		this.config = {
			easing : "easeInOutCubic",
			time : 800
		};
	}

	tora.scroller.prototype = {
		init : function(config){
			if(config){
				this.config = config;
			}
		},
		setEvent : function(){
			$('a[href^="#"]').click(this.config,function(e,config){
				//クリックされたリンクのhref属性からコンテンツを取得
				var $target = $($(this).attr("href"));
				//$targetの位置（該当コンテンツ）から、オフセット分引いて調整
				if (window.innerWidth <= 812) { //スマホ（画面幅812px以下）の場合のオフセット調整
					var $offset = 30; //sp
				} else {
					var $offset = 20; //pc
				}
				//$("html, body") をスクロールして、指定した位置（$offset）まで移動
				$("html,body").animate({"scrollTop" : $offset},e.data.time,e.data.easing);

				return false;
			});
		}
	};
	
	//設定
	var scroller = new tora.scroller();
	scroller.init({
		easing : "easeInOutCubic",
		time : 1000
	});
	$(function(){
		scroller.setEvent();
	});


	/*-----------------------------------
		menu_drawer
	-----------------------------------*/
	var btnMenu = $('.jsBtnMenu');
	$(btnMenu).click(function(e){
		$('body').toggleClass('jsScrollLock'); //*1
		$(btnMenu).add($('.jsDrawerArea')).add($('.headerLogo')).add($('.headerInner')).toggleClass('jsOpen');
		e.preventDefault();
	});
	
	//ページ内アンカークリック時のメニュー非表示
	$('#headerWrapper a[href*="#"]').on('click',function() {
		$('body').removeClass('jsScrollLock');//.jsScrollLock削除
		$(btnMenu).add($('.jsDrawerArea')).add($('.headerLogo')).add($('.headerInner')).removeClass('jsOpen');//.jsOpen削除
	});

	/* memo
	*1:cssでbodyのスクロールを禁止に
		body.jsScrollLock{
			overflow: hidden;
		}
	*/


	/*-----------------------------------
		header scroll
	-----------------------------------*/
	// 変数に要素を入れる
	var header = $('#headerWrapper');

	// スクロールして一定位置を超えたらクラス付与
	$(window).on('load scroll', function () {
		if ($(this).scrollTop() > 30) {
			header.addClass('jsHeaderScroll');
		} else {
			header.removeClass('jsHeaderScroll');
		}
	});
	

	/*-----------------------------------
		pageTop
	-----------------------------------*/
	//変数にクラスを入れる
	var pageTop = $('#pageTop');
	
	//スクロールしてページトップから100に達したらボタンを表示
	//必須css：opacity: 0; visibility: hidden;
	$(window).on('load scroll', function(){
		if($(this).scrollTop() > 100) {
			pageTop.addClass('active');
		}else{
			pageTop.removeClass('active');
		}
	});
});